<template>
   <div class="espera-overlay">
      <div class="espera-card">

         <!-- Estado: contando (cupo detectado) -->
         <template v-if="cuentaAtras > 0">
            <div class="cuenta-circulo mb-4">
               <svg class="cuenta-svg" viewBox="0 0 80 80">
                  <circle class="cuenta-track" cx="40" cy="40" r="34" />
                  <circle
                     class="cuenta-progress"
                     cx="40" cy="40" r="34"
                     :stroke-dashoffset="dashOffset"
                  />
               </svg>
               <span class="cuenta-numero">{{ cuentaAtras }}</span>
            </div>
            <p class="espera-titulo">¡Cupo disponible!</p>
            <p class="espera-carnet">
               <v-icon color="rgba(255,255,255,0.7)" size="16" class="mr-1">fa-id-card</v-icon>
               {{ carnet }}
            </p>
            <p class="espera-mensaje">
               Colecturía Digital UNICAES estará disponible en un momento.<br>
               Por favor, no cierre esta ventana.
            </p>
         </template>

         <!-- Estado: esperando (sin cupo aún) -->
         <template v-else>
            <div class="tabs-ilustracion mb-6">
               <div class="tab tab-activa">
                  <v-icon color="white" size="22">fa-globe</v-icon>
                  <span>Colecturía</span>
               </div>
               <div class="tab tab-activa">
                  <v-icon color="white" size="22">fa-globe</v-icon>
                  <span>Colecturía</span>
               </div>
               <div class="tab tab-bloqueada">
                  <v-icon color="white" size="22">fa-ban</v-icon>
                  <span>Esta ventana</span>
               </div>
            </div>

            <p class="espera-titulo">Límite de ventanas alcanzado</p>

            <p class="espera-carnet">
               <v-icon color="rgba(255,255,255,0.7)" size="16" class="mr-1">fa-id-card</v-icon>
               {{ carnet }}
            </p>

            <p class="espera-mensaje">
               Solo debe tener <strong>2 pestañas</strong> de Colecturía Digital UNICAES abiertas al mismo tiempo.<br>
               Por favor, cierre una de las otras ventanas para continuar.
            </p>

            <div class="espera-pulse-wrapper mb-4">
               <div class="espera-pulse"></div>
               <p class="espera-checking">Verificando disponibilidad...</p>
            </div>

            <p class="espera-aviso">
               Esta ventana se activará automáticamente cuando cierre otra pestaña de Colecturía Digital UNICAES.
            </p>
         </template>

      </div>
   </div>
</template>

<script>
export default {
   name: 'EsperaSesiones',
   props: {
      carnet: {
         type: String,
         default: ''
      },
      cuentaAtras: {
         type: Number,
         default: -1
      }
   },
   computed: {
      // Círculo SVG: circunferencia = 2π×34 ≈ 213.6
      dashOffset() {
         const circunferencia = 2 * Math.PI * 34
         const progreso = this.cuentaAtras / 5
         return circunferencia * (1 - progreso)
      }
   }
}
</script>

<style scoped>
.espera-overlay {
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   z-index: 9999;
   background: linear-gradient(145deg, #6b0201 0%, #A00402 50%, #c00503 100%);
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 16px;
}

.espera-card {
   background: rgba(255, 255, 255, 0.08);
   border: 1px solid rgba(255, 255, 255, 0.15);
   border-radius: 20px;
   padding: 48px 40px;
   max-width: 540px;
   width: 100%;
   text-align: center;
   backdrop-filter: blur(10px);
   box-shadow: 0 24px 64px rgba(0, 0, 0, 0.4);
}

/* ── Cuenta regresiva ── */
.cuenta-circulo {
   position: relative;
   width: 100px;
   height: 100px;
   margin: 0 auto;
}

.cuenta-svg {
   width: 100px;
   height: 100px;
   transform: rotate(-90deg);
}

.cuenta-track {
   fill: none;
   stroke: rgba(255, 255, 255, 0.15);
   stroke-width: 6;
}

.cuenta-progress {
   fill: none;
   stroke: #deab2f;
   stroke-width: 6;
   stroke-linecap: round;
   stroke-dasharray: 213.6;
   transition: stroke-dashoffset 0.9s linear;
}

.cuenta-numero {
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
   font-size: 36px;
   font-weight: 800;
   color: #ffffff;
   line-height: 1;
}

/* ── Ilustración de pestañas ── */
.tabs-ilustracion {
   display: flex;
   justify-content: center;
   gap: 12px;
}

.tab {
   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 6px;
   padding: 14px 18px;
   border-radius: 12px;
   font-size: 11px;
   font-weight: 600;
   letter-spacing: 0.5px;
   color: #fff;
}

.tab-activa {
   background: rgba(255, 255, 255, 0.18);
   border: 2px solid rgba(255, 255, 255, 0.3);
}

.tab-bloqueada {
   background: rgba(229, 57, 53, 0.35);
   border: 2px dashed rgba(229, 57, 53, 0.7);
   opacity: 0.85;
   animation: parpadeo 2s ease-in-out infinite;
}

@keyframes parpadeo {
   0%, 100% { opacity: 0.85; }
   50%       { opacity: 0.4;  }
}

/* ── Textos ── */
.espera-titulo {
   font-size: 26px;
   font-weight: 700;
   color: #ffffff;
   margin-bottom: 8px;
   letter-spacing: -0.3px;
}

.espera-carnet {
   font-size: 13px;
   color: rgba(255, 255, 255, 0.65);
   margin-bottom: 20px;
   letter-spacing: 1px;
   text-transform: uppercase;
}

.espera-mensaje {
   font-size: 16px;
   color: rgba(255, 255, 255, 0.88);
   line-height: 1.7;
   margin-bottom: 32px;
}

.espera-mensaje strong {
   color: #fff;
}

/* ── Indicador de polling ── */
.espera-pulse-wrapper {
   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 12px;
}

.espera-pulse {
   width: 14px;
   height: 14px;
   background: #deab2f;
   border-radius: 50%;
   animation: pulse 1.8s ease-in-out infinite;
}

@keyframes pulse {
   0%   { transform: scale(1);   box-shadow: 0 0 0 0 rgba(222, 171, 47, 0.6); }
   50%  { transform: scale(1.1); box-shadow: 0 0 0 12px rgba(222, 171, 47, 0);  }
   100% { transform: scale(1);   box-shadow: 0 0 0 0 rgba(222, 171, 47, 0);  }
}

.espera-checking {
   font-size: 13px;
   color: rgba(255, 255, 255, 0.5);
   margin: 0;
   letter-spacing: 0.3px;
}

.espera-aviso {
   font-size: 13px;
   color: rgba(255, 255, 255, 0.45);
   margin: 0;
   line-height: 1.6;
}
</style>
